import { useVuexGetters } from '@scfe-common/micro-frontend-utils';

var useHasPermission = function (permission) {
    var _a;
    return !!((_a = useVuexGetters('hasPermission')) === null || _a === void 0 ? void 0 : _a(permission));
};

export { useHasPermission as default };
